import React from "react";
import Skeleton from "../../common/Skeleton";

const StockFundamentalRatioSkeleton = ({
  isTabbedView,
}: {
  isTabbedView?: boolean;
}) => {
  // Array to match the 5 sections in the actual modal
  const sections = [5, 4, 5, 5, 3];

  return (
    <div
      className={`flex flex-col ${isTabbedView ? "w-full" : "h-full flex-1 overflow-hidden"}`}
    >
      <div
        className={`grid md:grid-cols-3 gap-2 space-y-6 ${
          isTabbedView
            ? "px-3 py-2"
            : "flex-1 min-h-0 overflow-y-auto px-6 py-1 custom-scroll"
        }`}
      >
        {sections.map((count, index) => (
          <div key={index} className="space-y-2 h-[250px]">
            {/* Section Title */}
            <Skeleton className="w-32 h-4 mb-2 rounded bg-gray-300 dark:bg-gray-600" />

            {/* Grid/List */}
            <div
              className={`grid gap-0 border border-gray-200 dark:border-gray-700 rounded-md overflow-hidden ${count > 3 ? "grid-cols-1 md:grid-cols-1" : "!flex flex-col gap-1.5"}`}
            >
              {[...Array(count)].map((_, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between px-4 py-2 border-b border-gray-100 dark:border-gray-800 last:border-0"
                >
                  <Skeleton className="w-24 h-4 rounded" />
                  <Skeleton className="w-16 h-4 rounded" />
                </div>
              ))}
            </div>
          </div>
        ))}
        {/* Score Section */}
        <div className="flex flex-col items-start justify-start">
          <Skeleton className="w-24 h-4 mb-2 rounded bg-gray-300 dark:bg-gray-600" />
          <div className="w-full h-[200px] flex items-center justify-center">
            <Skeleton className="w-40 h-20 rounded-t-full rounded-b-none" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockFundamentalRatioSkeleton;
